/**
 * Default: Vendors > Voice Reader
 */

import {setRootVar} from "@ifabnpm/bootstrap/utils.js";
import {load} from "@ifabnpm/bootstrap/utils/load.js";

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';

const init = async () => {
	const fakeButton = `<div class="button -primary -s">
		<span aria-hidden="true" class="button__background">
			<svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 200 95" xmlns="http://www.w3.org/2000/svg">
				<use xlink:href="#svg-bg-button"></use>
			</svg>
		</span>
		<span class="button__prefix">
			<span aria-hidden="true" class="svg-icon" data-svg-icon>
				<svg aria-hidden="true" preserveAspectRatio="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
					<use xlink:href="#svg-icon-play"></use>
				</svg>
			</span>
		</span>
		<span class="button__label">${window.pageInstance.settings.translations.readAloud}</span>
	</div>`

	window.vrweb_customerid        = '11577';
	window.vrweb_path_prefix       = '//vrweb15.linguatec.org/VoiceReaderWeb15User/player20/scripts/';
	window.vrweb_player_form       = '1';
	window.vrweb_player_type       = 'popup';
	window.vrweb_player_color      = 'black';
	window.vrweb_icon              = '00';
	window.vrweb_iconcolor         = 'black';
	window.vrweb_sndgender         = 'W';
	window.vrweb_readelementsclass = 'page-main,read';
	window.vrweb_exclelementsclass = 'dont-read,form,images,slider,details,drawer,figure,media-gallery,nav.nav-subpage,player,privacy-info,tab-group,pagination,button,icon-buttonfancybox__container';
	// window.vrweb_icon              = `<span class="voicereader-player__text">${window.pageInstance.settings.translations.readAloud}</span>`;
	window.vrweb_icon              = fakeButton;
	window.vrweb_guilang           = window.pageInstance.settings.language['iso-639-1'];
	window.vrweb_lang              = window.pageInstance.settings.language.hreflang;

	Manipulator.elementAppend('<div aria-hidden="true" class="vrweb_player_main" data-provider="voice-reader"></div>');

	load([{
		src: 'https://vrweb15.linguatec.org/VoiceReaderWeb15User/player20/styles/blue/player_skin.css',
		id : 'voicereaderCss'
	}, {
		src  : 'https://vrweb15.linguatec.org/VoiceReaderWeb15User/player20/scripts/readpremium20.js',
		defer: true,
		id   : 'voicereaderJs'
	}]).then((data) => {
		// console.log(data);
	});
};

// Export
export default init;
